export { default as LocalizedLink } from './LocalizedLink'
